import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from '@app/Common/toast';
import { ModuleService } from '../../Services/module.service';
import { ModuleLinkedFieldsComponent } from '../LinkedFields/module.linked-fields.component';

@Component({
    selector: 'aw-linked-fields',
    templateUrl: './linked-fields.component.html',
    styleUrls: ['./linked-fields.component.less'],
    imports: [ModuleLinkedFieldsComponent]
})
export class LinkedFieldsComponent implements OnInit {
  private version = 1;

  moduleId: string;

  constructor(private activatedRoute: ActivatedRoute,
    public moduleService: ModuleService,
    public dialog: MatDialog,
    public toast: ToastService) { }

  ngOnInit() {
    this.moduleId = this.activatedRoute.parent.snapshot.params.moduleId;
    this.version = this.activatedRoute.parent.snapshot.params.version;
  }

}
